const newsletter = {
  page: {
    title: 'Subscribe to Free Newsletter',
  },
  forms: {
    salutation: 'Salutation',
    firstName: 'First Name *',
    lastName: 'Last Name *',
    email: 'Email Address *',
    policy: {
      termsOfUse: 'Terms of Use',
      privacyPolicy: 'Privacy Policy',
      1: 'I have taken note of the',
      2: 'and',
      3: 'and agree to their applicability.',
    },
    pleaseFill: '* Please fill in the mandatory fields',
    subscribe: 'Subscribe',
    newHere: 'New Here?',
    join: 'Register Now',
    forgotPassword: 'Forgot Password?',
    error: 'You are already subscribed to this newsletter.',
    successTitle: 'Your Newsletter Subscription',
    successText: 'Thank you for subscribing to the free newsletter from IhreApotheken. You have just received a confirmation email.',
    button: 'Go to Homepage',
  },
}

export default newsletter
